import { render, staticRenderFns } from "./DocFields.vue?vue&type=template&id=3a63e636&"
import script from "./DocFields.vue?vue&type=script&lang=js&"
export * from "./DocFields.vue?vue&type=script&lang=js&"
import style0 from "./DocFields.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports